import { render, staticRenderFns } from "./SupportingDocs.vue?vue&type=template&id=6b2e510d&"
import script from "./SupportingDocs.vue?vue&type=script&lang=js&"
export * from "./SupportingDocs.vue?vue&type=script&lang=js&"
import style0 from "./SupportingDocs.vue?vue&type=style&index=0&id=6b2e510d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports